<template>
  <div class="app-container">
    <PageTitle title="结算记录" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-date-picker
        v-model="listQuery.use_date"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="出发开始日期"
        end-placeholder="出发结束日期"
        @change="handleUseDate"
        style="margin-right: 10px"
      >
      </el-date-picker>
      <TimeSelect
        @changeInterval="handleInterval"
        v-model="listQuery.interval_time"
        customStyle="margin: 0 10px 10px 0; vertical-align: middle; width: 160px"
      />
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入项目名称"
        v-model="listQuery.project_name"
        @change="handleProjectName"
      ></el-input>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.trip_type"
        placeholder="订单类型"
        @change="handleTripType"
      >
        <el-option label="拼团" :value="1"></el-option>
        <el-option label="包团" :value="2"></el-option>
      </el-select>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.service_status"
        placeholder="服务状态"
        @change="handleServiceStatus"
      >
        <el-option label="未开始" :value="1"></el-option>
        <el-option label="进行中" :value="2"></el-option>
        <el-option label="已完成" :value="3"></el-option>
      </el-select>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.billing_status"
        placeholder="结算状态"
        @change="handleBillingStatus"
      >
        <el-option label="未结算" :value="1"></el-option>
        <el-option label="已结算" :value="2"></el-option>
      </el-select>

      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="导游手机号"
        v-model="listQuery.guide_mobile"
        @change="handleGuideMobile"
      ></el-input>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="导游姓名"
        v-model="listQuery.guide_name"
        @change="handleGuideName"
      ></el-input>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-download" @click="handleExport"
        >导出</el-button
      >
    </div>
    <el-button
      v-if="sendBtnShow"
      type="primary"
      size="mini"
      @click="allAccount"
      style="margin-bottom: 10px"
      >批量结算</el-button
    >
    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:interval_time>
        <el-table-column label="场次" width="100" align="center">
          <template slot-scope="scope"> {{ scope.row.interval_time }}场 </template>
        </el-table-column>
      </template>

      <template v-slot:trip_type>
        <el-table-column label="订单类型" width="100" align="center">
          <template slot-scope="scope"> {{ ['', '拼团', '包团'][scope.row.trip_type] }} </template>
        </el-table-column>
      </template>
      <template v-slot:guide>
        <el-table-column label="导游" width="180" align="center">
          <template slot-scope="scope">
            {{ scope.row.guide.name }}｜{{ scope.row.guide.mobile }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:user_num>
        <el-table-column label="游客人数" width="80" align="center">
          <template slot-scope="scope"> {{ scope.row.user_num }}人 </template>
        </el-table-column>
      </template>
      <template v-slot:service_fee>
        <el-table-column label="服务费用" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.service_fee }}{{ scope.row.service_fee === '-' ? '' : '元' }}</template
          >
        </el-table-column>
      </template>
      <template v-slot:compensation_fee>
        <el-table-column label="补偿费用" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.compensation_fee
            }}{{ scope.row.compensation_fee === '-' ? '' : '元' }}</template
          >
        </el-table-column>
      </template>
      <template v-slot:service_status>
        <el-table-column label="服务状态" width="100" align="center">
          <template slot-scope="scope">
            {{ ['', '未开始', '进行中', '已完成'][scope.row.service_status] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:billing_status>
        <el-table-column label="结算状态" width="100" align="center">
          <template slot-scope="scope">
            {{ ['', '未结算', '已结算', '已作废'][scope.row.billing_status] }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="300" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.can_process_invoice"
              type="primary"
              size="mini"
              @click="handleConfirmAccount(scope.row.trip_service_id)"
              >确认结算</el-button
            >
            <el-button
              v-if="scope.row.can_process_compensation"
              type="primary"
              size="mini"
              @click="$refs.compensation.handleCompensationFee(scope.row.trip_service_id)"
              >补偿费用</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="$refs.assignRecord.handleAssignRecord(scope.row.trip_service_id)"
              >派单记录</el-button
            >
            <el-button
              type="primary"
              size="mini"
              v-if="scope.row.billing_status === 1"
              @click="handleCancel(scope.row.trip_service_id)"
              >作废</el-button
            >
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="table-footer">
      <p>服务费总金额：{{ total_fee }}元</p>
      <div class="pagination-container">
        <pagination
          :total="count"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.size"
          @pagination="fetchData"
        />
      </div>
    </div>

    <!-- <OrderDrawer ref="drawer" /> -->
    <Compensation ref="compensation" />
    <AssignRecord ref="assignRecord" />
  </div>
</template>

<script>
import {
  getList,
  accountConfirm,
  exportAccounting,
  allBatchConfirm,
  cancelBatch
} from '@/api/accountingRecord'
import PageTitle from '@/components/PageTitle'
import TimeSelect from '@/components/TimeSelect'
// import OrderDrawer from '@/components/OrderDrawer'
import Compensation from './components/Compensation'
import AssignRecord from './components/AssignRecord'
export default {
  name: 'accountingRecord',
  components: {
    PageTitle,
    TimeSelect,
    AssignRecord,
    Compensation
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      total_fee: 0,
      listQuery: {
        page: 1,
        size: 10,
        city: '',
        project_name: '',
        trip_type: '',
        guide_name: '',
        guide_mobile: '',
        interval_time: '',
        service_status: '',
        billing_status: '',
        use_date: '',
        use_date_start: '',
        use_date_end: ''
      },
      service_ids: [],
      sendBtnShow: false,
      columns: [
        { type: 'selection', slot: 'selection' },
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '出发日期',
          width: '120',
          prop: 'use_date',
          align: 'center'
        },
        {
          label: '场次',
          slot: 'interval_time'
        },
        {
          label: '项目',
          width: '120',
          prop: 'project_name',
          showOverflowTooltip: true
        },
        {
          label: '订单类型',
          slot: 'trip_type'
        },
        {
          label: '导游信息',
          slot: 'guide'
        },
        {
          label: '游客人数',
          slot: 'user_num'
        },
        {
          label: '服务费用',
          slot: 'service_fee'
        },
        {
          label: '补偿费用',
          slot: 'compensation_fee'
        },
        {
          label: '服务状态',
          slot: 'service_status'
        },
        {
          label: '结算状态',
          slot: 'billing_status'
        },

        {
          label: '结算时间',
          width: '140',
          align: 'center',
          prop: 'processed_time'
        },

        {
          label: '操作',
          slot: 'action'
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    /**
     * @description: 判断是否可选
     * @return {*}
     */
    checkSelectable(row) {
      return row.billing_status == 1
    },
    // 获取数据
    fetchData() {
      this.listLoading = true
      const query = { ...this.listQuery }
      if (query.use_date_start && query.use_date_end) {
        query.use_date = [query.use_date_start, query.use_date_end]
      }
      if (query.pay_time_start && query.pay_time_end) {
        query.pay_time = [query.pay_time_start, query.pay_time_end]
      }

      getList(query).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.total_fee = res.data.total_fee ? res.data.total_fee : 0
        this.listLoading = false
      })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handleUseDate(e) {
      if (e) {
        this.listQuery.use_date_start = e[0]
        this.listQuery.use_date_end = e[1]
      } else {
        this.listQuery.use_date_start = ''
        this.listQuery.use_date_end = ''
      }
      this.handleFilter()
    },
    handleInterval(e) {
      this.listQuery.interval_time = e
      this.handleFilter()
    },
    handleProjectName(e) {
      this.listQuery.project_name = e
      this.handleFilter()
    },
    handleTripType(e) {
      this.listQuery.trip_type = e
      this.handleFilter()
    },
    handleServiceStatus(e) {
      this.listQuery.service_status = e
      this.handleFilter()
    },
    handleBillingStatus(e) {
      this.listQuery.billing_status = e
      this.handleFilter()
    },
    handleGuideMobile(e) {
      this.listQuery.guide_mobile = e
      this.handleFilter()
    },
    handleGuideName(e) {
      this.listQuery.guide_name = e
      this.handleFilter()
    },
    /**
     * @description: 批量结算
     * @return {*}
     */
    allAccount() {
      const _this = this
      _this
        .$confirm('是否确认结算当前选中订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          allBatchConfirm({ trip_service_ids: _this.service_ids }).then(() => {
            _this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            _this.fetchData()
          })
        })
        .catch(() => {})
    },
    handleExport() {
      const query = { ...this.listQuery }
      if (query.pay_time && query.pay_time.length) {
        query.pay_time_start = query.pay_time[0]
        query.pay_time_end = query.pay_time[1]
      }
      exportAccounting(query).then((res) => {
        import('@/vendor/Export2Excel').then((excel) => {
          excel.export_json_to_excel({
            header: res.data.header,
            data: res.data.data,
            filename: '结算记录'
          })
        })
      })
    },
    /**
     * @description:重置
     * @return {*}
     */
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        project_name: '',
        trip_type: '',
        guide_name: '',
        guide_mobile: '',
        service_status: '',
        billing_status: ''
      }
      this.fetchData()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.sendBtnShow = !!e.length > 0
      this.service_ids = e.map((item) => item.trip_service_id)
    },
    /**
     * @description: 作废
     * @return {*}
     */
    handleCancel(trip_service_id) {
      this.$confirm('是否确认作废当前订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          cancelBatch({ trip_service_id }).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },

    /**
     * @description: 确认结算
     * @return {*}
     */
    handleConfirmAccount(trip_service_id) {
      this.$confirm('是否确认结算当前订单？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          accountConfirm({ trip_service_id }).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
.table-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
